import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getMessage } from "CONFIG/i18n";

import withErrorHandler from "COMPONENTS/withErrorHandler/withErrorHandler";
import UserJoin from "./UserJoin";

import {
  sessionActions as actionFactory,
  organisationAction,
  logoutAction,
  loginAction
} from "CONFIG/ActionFactory";
import { setUserName } from "./UserJoinAction";
import { CONFIG, USER_ROLES, USER_ADMISSION_STATUS, ERROR } from "UTILS/Constants";
import {
  checkEmpty, getURLParameter, removeTrailingSlash ,getUrlPathExcludingSearchString, getStringArrayInLowerCase,
  getTerminalInfo,
} from "UTILS/Utility";

import img_header_logo from "ASSETS/Images/img_header_logo.webp";
import { selectToken } from "../Whiteboard/selectors";
import { getOwnSpeedTestError } from "REDUX/Selector/UserSelector"

import SpeedTestHelper from 'COMPONENTS/SpeedTest/speedTestHelper';
const speedTestHelper = new SpeedTestHelper();

export class UserJoinContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionKey: "",
      spinnerVisibility: false,
      isSSOInfoCalled: false,
      isSpeedTestRunning: true,
      speedTestCountTime: 15,
      speedTest: {},
    };
    this.speedTestCountDownInterval = null;
  }

  componentDidMount() {
    if (this.props.token) {
      logoutAction.logoutAction();
    }
    this.getSessionKey();
    if((this.props.role !== USER_ROLES.SUPER_ADMIN ||
       this.props.role !== USER_ROLES.ADMIN) &&
       !this.state.isSSOInfoCalled) {
      let isPathPresentInConstants = getStringArrayInLowerCase(CONFIG.path).includes(
        getUrlPathExcludingSearchString(window.location.pathname).toLowerCase());
  
      console.log(`Routing: pathExists ${isPathPresentInConstants}`);
      if (isPathPresentInConstants) {
        if(this.props.uriIdentifier !== '/') {
          this.setURIidentifier("/");
        }
      } else {
        this.getSSOInfo();
      }
    }
    this.startSpeedTest();
  }

  componentWillUnmount() {
    speedTestHelper.clear();
    if (typeof this.speedTestCountDownInterval === "number") {
      clearInterval(this.speedTestCountDownInterval);
    }
  }

  startSpeedTest = () => {
    actionFactory.setOwnSpeedTestError(null);

    this.speedTestCountDownInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.speedTestCountTime <= 0) {
          clearInterval(this.speedTestCountDownInterval);
        } else {
          return { speedTestCountTime: prevState.speedTestCountTime -1 };
        }
      });
    }, 1000);

    speedTestHelper.startSpeedTest(
      this.onComplete,
      this.onServerError,
      this.onTimeoutError,
    )
  }
  onComplete = (speedTest) => {
    this.setState({ 
      isSpeedTestRunning: false,
      speedTest,
    });
  }
  onServerError = () => {
    this.setState({ 
      isSpeedTestRunning: false,
      speedTest: {
        result: -1,
      }
    });
  }
  onTimeoutError = () => {
    actionFactory.setOwnSpeedTestError(ERROR.SPEED_TEST_TIME_OUT);
    this.setState({ 
      isSpeedTestRunning: false,
      speedTest: {
        result: -1,
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.getSessionKey();
  }

  getSSOInfo = () => {
    this.setState({
      isSSOInfoCalled: true
    })
    let urlPath = removeTrailingSlash(window.location.pathname).split("/");

    // get sso info api should not get called for superadmin path
    if((urlPath[1] && urlPath[1].toLowerCase() === 'superadmin') 
    || (urlPath[1] && urlPath[1].toLowerCase() === 'admin')) {
      return;
    }

    if(urlPath[1] != (this.props.uriIdentifier.replace("/"), '')) {
      loginAction.getSSOInfo(urlPath[1]).then((response) => {
        loginAction.setURIidentifier('/' + response.uriIdentifier);
        organisationAction.setLogoUrl(response.logoUrl);
      }).catch(() => {
        loginAction.setURIidentifier('/');
      });
    }
  }

  getSessionKey = () => {
    // get session key from query parameter
    const sessionKey = getURLParameter("sessionKey");
    this.setState({
      sessionKey: sessionKey,
    });
  };

  handleProceed = (userName, errorcallBackFun) => {
    //errorcallBackFun to pass error code
    this.setState({
      spinnerVisibility: true,
    });

    if (checkEmpty(this.state.sessionKey)) {
      errorcallBackFun("ERR_MSG_SESSION_KEY");
      this.setState({
        spinnerVisibility: false,
      });
    } else {
      let user = userName;
      if(checkEmpty(user.trim())) {
        user = getMessage("GUEST");
      }
      this.props.setUserName(user);
      getTerminalInfo().then ( terminalInfo => {
        actionFactory.joinSessionAction(this.state.sessionKey, this.props.uriIdentifier, terminalInfo, this.state.speedTest, user).then(
          (response) => {
            let logoUrl = response.data.data.logoUrl;
            if (!logoUrl) {
              logoUrl = img_header_logo;
            }
            organisationAction.setLogoUrl(logoUrl);
            this.setState({
              spinnerVisibility: false,
            });
            errorcallBackFun("");
            if (response.data.data.role == USER_ROLES.USER
                && response.data.data.admissionStatus != USER_ADMISSION_STATUS.ADMITTED
            ) {
              this.props.history.push(CONFIG.path.waitingRoom);
            } else {
              this.props.history.push(CONFIG.path.dashboard);
            }
          },
          (error) => {
            errorcallBackFun(
              error.code === "INVALID_SESSION"
                ? "SESSION_CLOSED"
                : error.code
            );
            this.setState({
              spinnerVisibility: false,
            });
          }
        );
      });
    }
  };

  handleJoinWithPasscode=(sessionDetails, userName, errorcallBackFun) => {
    this.setState({
      spinnerVisibility: true,
    });
    actionFactory.getSessionKeyFromPasscode(sessionDetails).then((response)=>{
      let user = userName;
      if(checkEmpty(user.trim())) {
        user = getMessage("GUEST");
      }
      this.props.setUserName(user);
      getTerminalInfo().then ( terminalInfo => {
        actionFactory.joinSessionAction(response.data.sessionKey, this.props.uriIdentifier, terminalInfo, this.state.speedTest, user).then(
          (response) => {
            let logoUrl = response.data.data.logoUrl;
            if (!logoUrl) {
              logoUrl = img_header_logo;
            }
            organisationAction.setLogoUrl(logoUrl);
            errorcallBackFun("");
            if (response.data.data.role == USER_ROLES.USER
                && response.data.data.admissionStatus != USER_ADMISSION_STATUS.ADMITTED
            ) {
              this.props.history.push(CONFIG.path.waitingRoom);
            } else {
              this.props.history.push(CONFIG.path.dashboard);
            }
            this.setState({
              spinnerVisibility: true,
            });
          },
          (error) => {
            errorcallBackFun(
              error.code === "INVALID_SESSION"
                ? "SESSION_CLOSED"
                : error.code
            );
            this.setState({
              spinnerVisibility: false,
            });
          }
        );
      });
    },
    (error)=>{
      errorcallBackFun(
        error.code === "INVALID_SESSION"
          ? "SESSION_CLOSED"
          : error.code
      );
      this.setState({
        spinnerVisibility: false,
      });
    })
  }
  
  render() {
    return (
      <React.Fragment>
        <UserJoin
          handleProceed={this.handleProceed}
          spinnerVisibility={this.state.spinnerVisibility}
          sessionKey={this.state.sessionKey}
          handleJoinWithPasscode={this.handleJoinWithPasscode}
          gottenWording={this.props.gottenWording}
          isWordingGotten={this.props.isWordingGotten}
          isSpeedTestRunning={this.state.isSpeedTestRunning}
          speedTestRemainingTime={this.state.speedTestCountTime}
          speedTestResult={this.state.speedTest.result}
          ownSpeedTestError={this.props.ownSpeedTestError}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { 
    token: selectToken(state),
    uriIdentifier: state.UserReducer.uriIdentifier,
    gottenWording: state.OrganisationReducer.wordingUrl,
    isWordingGotten: state.OrganisationReducer.isWordingFetched,
    ownSpeedTestError: getOwnSpeedTestError(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ 
    setUserName: setUserName
  }, dispatch);
};

export default withErrorHandler(
  connect(mapStateToProps, mapDispatchToProps)(UserJoinContainer)
);
